/* ready */
$(function() {
  'use strict';
  
  var incPath;
  if(document.URL.match(/carbon-fiber\/en\//)) {
    incPath = "/carbon-fiber/en/inc/";
  }else if(document.URL.match(/carbon-fiber\/cn\//)) {
    incPath = "/carbon-fiber/cn/inc/";
  }else{
    incPath = "/carbon-fiber/inc/";
  }
  $('.l-header').load(incPath + 'header.html', function() {
    /* ロゴ */
    var path = location.pathname;
    if (path == '/carbon-fiber/') {
      $('.l-header__logo-txt').replaceWith( function() {
        $(this).replaceWith('<h1 class="l-header__logo-txt u-osw">' + $(this).html() + '</h1>');
      });
    }
    
    /* Language */    
    $('.l-header__link__lang').hover(function() {
        $(this).addClass('is-active');
      }, function() {
        $(this).removeClass('is-active');
      }
    );

    /* メガナビ */
    $('.l-gnavi__list__has-mega').hover(function() {
      var deviceWidth = $(window).width();

      if (deviceWidth > 1024) {
        $(this).addClass('is-active');
      } else {
        $(this).removeClass('is-active');
      }
    }, function() {
      var deviceWidth = $(window).width();

      if (deviceWidth > 1024) {
        $(this).removeClass('is-active');
      } else {
        $(this).removeClass('is-active');
      }
    });

    /* 追従ナビ */
    $(window).scroll(function() {
      var deviceWidth = window.innerWidth;
      var scroll = $(window).scrollTop();

      if (deviceWidth > 1024) {
        if (scroll > 300) {
          $('.l-header').addClass('is-fixed');
        } else {
          $('.l-header').removeClass('is-fixed');
        }
      } else {
        $('.l-header').removeClass('is-fixed');
      }
    });

    /* SPグロナビ */
    $('.l-header__menu').click(function() {
      var deviceWidth = $(window).width();

      if (deviceWidth < 1025) {
        $(this).toggleClass('is-active').parent().next().stop().slideToggle();
      }
    });

    /* SPメガナビ */
    $('.l-gnavi__list__has-mega > span').click(function() {
      var deviceWidth = $(window).width();

      if (deviceWidth < 1025) {
        $(this).parent().toggleClass('is-open').find('.l-mnavi').stop().slideToggle();
      }
    });
  });

  $('.l-footer').load(incPath + 'footer.html', function(){
    /* スムーススクロール */
    $('a[href^="#"], area[href^="#"]').on('click', function() {
      // スピード（ミリ秒）
      var speed = 300;
      // アンカーの値取得
      var href = $(this).attr('href');
      // 移動先を取得
      var target = $(href == "#" || href == "" ? 'html' : href);
      // 移動先を座標で取得
      var position;
      if ($(this).parent().hasClass('l-pagetop')) {
        position = target.offset().top;
      } else {
        position = target.offset().top - $('.l-header').outerHeight();
      }
      // アニメーション
      $('body,html').not(':animated').animate({scrollTop:position}, speed, 'swing');
      return false;
    });
  });

  /* ページトップ */
  $(window).scroll(function() {
    var deviceWidth = window.innerWidth;
    var scroll = $(window).scrollTop();

    if (scroll > 300) {
      $('.l-pagetop').fadeIn();
    } else {
      $('.l-pagetop').fadeOut();
    }

    var scrollHeight = $(document).height();
    var scrollPosition = $(window).height() + scroll;
    var pagetopOffsetB = $('.l-pagetop').css('bottom');
    var pagetopHeight = $('.l-pagetop').height();
    var footerOffsetT = $('.l-footer').outerHeight() - parseInt(pagetopOffsetB) - (pagetopHeight / 2);

    if ( scrollHeight - scrollPosition  <= footerOffsetT ) {
      $('.l-pagetop').addClass('is-stopped');
    } else {
      $('.l-pagetop').removeClass('is-stopped');
    }
  });

  /* イメージマップ */
  $('img[usemap]').rwdImageMaps();
});